import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class GetContractorEmployeeServicesTypeUsageCommand extends 
 IRequestCommand<Array<ContractorServiceTypeUsageResponse>, ErrorDetails, IGetContractorEmployeeServicesTypeUsageCommandParameters> {

    override _commandType: CommandRequestType = CommandRequestType.GET;
    override _commandUrl = 'contractorEmployees/{contractorEmployeeId}/serviceTypeUsages';


    public override setParameters(parameters: IGetContractorEmployeeServicesTypeUsageCommandParameters) {
        this._commandUrl = this._commandUrl.replace('{contractorEmployeeId}', parameters.contractorEmployeeId);
    };
}

export interface IGetContractorEmployeeServicesTypeUsageCommandParameters extends ICommandParameters {
    contractorEmployeeId: string;
}

export interface ContractorServiceTypeUsageResponse extends ICommandResponse {
    /** Identificador del tipo de servicio */
    serviceTypeid: number;
  
    /** Nombre del tipo de servicio */
    serviceTypeName: string;
  
    /**
     * Límite del tipo de servicio + extra asignado al empleado.
     * Si no tiene límite, puede ser `null`
     */
    serviceTypeLimit: number | null;
  
    /** Suma entre uso pendiente y uso confirmado */
    currentUsage: number;

    /**
     * Tipos de Servicio que no requieren autorizacion
     */
    authRequired: boolean;

    extraLimit: number | null;

    periodType: string | null;
    periodTime: string | null;
}

export class AddAuthServiceTypeCommand extends IRequestCommand<ICommandResponse, ErrorDetails, IAddAuthServiceTypeCommandParameters> {
    override _commandType: CommandRequestType = CommandRequestType.POST;
    override _commandUrl = 'contractor/employee/{contractorEmployeeId}/services-type';

    public override setParameters(parameters: IAddAuthServiceTypeCommandParameters) {
        this._commandUrl = this._commandUrl.replace('{contractorEmployeeId}', parameters.contractorEmployeeId);
        this._commandBody = parameters;
    }
}

export interface IAddAuthServiceTypeCommandParameters extends ICommandParameters {
    contractorEmployeeId: string;
    serviceTypeId: string | number;
    userId?: number;
}

export class DeleteAuthServiceTypeCommand extends IRequestCommand<ICommandResponse, ErrorDetails, IDeleteAuthServiceTypeCommandParameters> {
    override _commandType: CommandRequestType = CommandRequestType.DELETE;
    override _commandUrl = 'contractor/employee/{contractorEmployeeId}/services-type/{serviceTypeId}';

    public override setParameters(parameters: IDeleteAuthServiceTypeCommandParameters) {
        this._commandUrl = this._commandUrl.replace('{contractorEmployeeId}', parameters.contractorEmployeeId);
        this._commandUrl = this._commandUrl.replace('{serviceTypeId}', parameters.serviceTypeId.toString());
    }
}

export interface IDeleteAuthServiceTypeCommandParameters extends ICommandParameters {
    contractorEmployeeId: string;
    serviceTypeId: number;
}

export class AddSubstractLimitServiceTypeCommand extends IRequestCommand<ICommandResponse, ErrorDetails, IAddSubstractLimitServiceTypeCommandParameters> {
    override _commandType: CommandRequestType = CommandRequestType.PUT;
    override _commandUrl = 'contractor/employee/{contractorEmployeeId}/services-type/{serviceTypeId}/limit';

    public override setParameters(parameters: IAddSubstractLimitServiceTypeCommandParameters) {
        this._commandUrl = this._commandUrl.replace('{contractorEmployeeId}', parameters.contractorEmployeeId);
        this._commandUrl = this._commandUrl.replace('{serviceTypeId}', parameters.serviceTypeId.toString());
        this._commandBody = parameters;
    }
}

export interface IAddSubstractLimitServiceTypeCommandParameters extends ICommandParameters {
    contractorEmployeeId: string;
    serviceTypeId: number;
    action: string;
    userId?: number;
}

export interface GetServiceTypesWithoutAuthForEmployeeResponse {
    serviceTypeid: number;
    serviceTypeName: string;
}

export class GetServiceTypesWithoutAuthForEmployeeCommand extends IRequestCommand<Array<GetServiceTypesWithoutAuthForEmployeeResponse>, ErrorDetails, IGetServiceTypesWithoutAuthForEmployeeCommandParameters> {
    override _commandType: CommandRequestType = CommandRequestType.GET;
    override _commandUrl = 'contractor/employee/{contractorEmployeeId}/services-type/without-auth';

    public override setParameters(parameters: IGetServiceTypesWithoutAuthForEmployeeCommandParameters) {
        this._commandUrl = this._commandUrl.replace('{contractorEmployeeId}', parameters.contractorEmployeeId);
        if (parameters.carrierId) {
             this._commandUrl += `?carrierId=${parameters.carrierId}`;
        }
    }
}

export interface IGetServiceTypesWithoutAuthForEmployeeCommandParameters extends ICommandParameters {
    contractorEmployeeId: string;
    carrierId?: number;
}